<template>
  <section>
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <workExperience/>
      <hr class="p-mt-5 p-mb-5"/>
      <education/>
      <hr class="p-mt-5 p-mb-5"/>
      <skills/>
      <hr class="p-mt-5 p-mb-5"/>
      <license/>
    </form>
  </section>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import DataTable from 'primevue/datatable'
import DeleteDialog from '../../../layout/dialog'
import Column from 'primevue/column'
import workExperience from './workExperience.vue'
import education from './education.vue'
import skills from './skills.vue'
import license from './license.vue'
export default {
  name: 'qualification',
  data() {
    return {
      loading: false,
      employeePositionId: null,
      deleteDialog: false,
      filters: {}
    }
  },
  computed: {},
  mounted() {
  },
  methods: {
    async addEmployeePosition() {
      if (this.name === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Name cannot be empty!', life: 3000})
        return
      }
      let employeeGroup = {
        id: this.employeePositionId,
        value: this.name,
        type: 'EmployeePosition'
      }
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createHrMasterSetup', employeeGroup)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updateHrMasterSetup', employeeGroup)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    // async deleteJobCategory(value) {
    //   if (value.trim() === '') {
    //     this.$toast.add({severity: 'error', summary: '', detail: 'Delete Reason cannot be empty!!', life: 3000})
    //     this.deleteDialog = true
    //     return
    //   }
    //   let deleteJobCategory = {
    //     id: this.jobCategoryId,
    //     deleteReason: value,
    //     type: 'JobCategory'
    //   }
    //   try {
    //     let response = await this.$store.dispatch('deleteHrMasterSetup', deleteJobCategory)
    //     if (response.data.status === 'SUCCESS') {
    //       this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
    //       this.deleteDialog = false
    //     }
    //   } catch (e) {
    //     this.$toast.add({severity: 'warn', summary: '', detail: 'Something went wrong!!', life: 3000})
    //     return
    //   }
    // },
    reset() {
      this.name = ''
      this.displayBasic = false
    }
    // openDeleteDialog(id) {
    //   this.jobCategoryId = id
    //   this.deleteDialog = true
    // },

    // cancelDelete(data) {
    //   this.deleteDialog = false
    // },
  },
  components: {
    Dialog,
    Button,
    InputText,
    DataTable,
    Column,
    DeleteDialog,
    workExperience,
    education,
    skills,
    license
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// qualification.vue?913626ba